export const breakpointsTokens = {
	xs: "375px", // mobile => @media (min-width: 0px) { ... }
	sm: "576px", // mobile => @media (min-width: 576px) { ... }
	md: "768px", // tablet => @media (min-width: 768px) { ... }
	lg: "1024px", // desktop => @media (min-width: 1024px) { ... }
	xl: "1280px", // desktop-lg => @media (min-width: 1280px) { ... }
	"2xl": "1536px", // desktop-xl => @media (min-width: 1536px) { ... }
};
